import React, { FunctionComponent } from "react"
import ChoiceInput, { IChoiceInputProps, ChoiceInputType } from "components/ChoiceInput/ChoiceInput"

const Radio: FunctionComponent<React.PropsWithChildren<Omit<IChoiceInputProps, "type">>> = (props) => {
    return <ChoiceInput
        {...props}
        type={ChoiceInputType.radio} />
}

export default Radio
